import { render } from "./InvoiceTab.vue?vue&type=template&id=34769f6f"
import script from "./InvoiceTab.vue?vue&type=script&lang=js"
export * from "./InvoiceTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__